/* HLF Offer Popup – Premium JS */
document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('hlfOpOverlay');
  if (!overlay) return;

  /* Move to body to escape stacking context issues */
  document.body.appendChild(overlay);

  const closeBtn  = document.getElementById('hlfOpCloseBtn');
  const declineBtn = document.getElementById('hlfOpDeclineBtn');
  const delaySec  = parseInt(overlay.getAttribute('data-delay') || '3', 10);

  /* Show-once guard (localStorage) */
  const storageKey = 'hlfOfferPopupDismissed';
  if (localStorage.getItem(storageKey)) return;

  setTimeout(() => {
    overlay.classList.add('is-visible');
    startTimer();
  }, delaySec * 1000);

  function closePopup() {
    overlay.classList.add('hiding');
    localStorage.setItem(storageKey, Date.now().toString());
    setTimeout(() => {
      overlay.classList.remove('is-visible', 'hiding');
    }, 250);
  }

  if (closeBtn)   closeBtn.addEventListener('click', closePopup);
  if (declineBtn) declineBtn.addEventListener('click', closePopup);

  /* Close on overlay click */
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closePopup();
  });

  /* Close on Escape key */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
      closePopup();
    }
  });

  /* ── Copy code ─────────────────────────────────────────────── */
  const copyBtn = document.getElementById('hlfOpCopyBtn');
  if (copyBtn) {
    copyBtn.addEventListener('click', () => {
      const codeEl = document.getElementById('hlfOpCodeDisplay');
      if (!codeEl) return;
      const code = codeEl.textContent.trim();
      const lbl  = document.getElementById('hlfOpCopyLabel');

      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).catch(() => {});
      } else {
        const ta = document.createElement('textarea');
        ta.value = code;
        ta.style.cssText = 'position:fixed;opacity:0;';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }

      copyBtn.classList.add('copied');
      if (lbl) lbl.textContent = 'Copied!';

      setTimeout(() => {
        copyBtn.classList.remove('copied');
        if (lbl) lbl.textContent = 'Copy';
      }, 2400);
    });
  }

  /* ── Countdown timer ───────────────────────────────────────── */
  let totalSecs = 14 * 60 + 59;
  let timerInterval;

  function startTimer() {
    if (timerInterval) return;
    const mmEl = document.getElementById('hlfOpMm');
    const ssEl = document.getElementById('hlfOpSs');
    if (!mmEl || !ssEl) return;

    timerInterval = setInterval(() => {
      if (totalSecs <= 0) {
        clearInterval(timerInterval);
        // Hide the timer row instead of showing 00:00
        const timerRow = mmEl.closest('.hlf-op-timer-row');
        if (timerRow) timerRow.style.display = 'none';
        return;
      }
      totalSecs--;
      mmEl.textContent = String(Math.floor(totalSecs / 60)).padStart(2, '0');
      ssEl.textContent = String(totalSecs % 60).padStart(2, '0');
    }, 1000);
  }
});
